import { IconContainer } from './styles';

const DiscountRedIcon = () => (
  <IconContainer
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="126"
    height="127"
    viewBox="0 0 126 127"
  >
    <path
      className={'background'}
      fill="#F34F66"
      d="M11.2,47.6C6.7,36.6,4.4,14.9,29.7,6.2c25.2-8.7,57.5-7.4,78.6,2.2c21,9.5,18,24.9,16,33.8
      c-1.9,9-10.3,29.2-29.6,55.9c-19.3,26.7-29.2,24.1-29.2,24.1S43.3,125.9,11.2,47.6z"
    />
    <g>
      <path
        className={'foreground'}
        fill="#FFFFFF"
        d="M82.1,122.4c-0.4,0-0.8,0-1.3-0.1c-2.5-0.2-6.8-1.2-12.9-4.4c-10.8-5.8-29.5-20-57.3-55.2l0,0
        c-2.3-2.9-7.7-10.7-8-20.4C2.2,32.7,7,24.6,16.8,18.2C38.5,4,70.4-2.8,94.3,1.5c10.1,1.8,17.2,6.1,21.1,12.6
        c3.4,5.7,3.9,12.1,4.2,16.3c0.7,10-2.3,32.1-13,61.2c-5.8,15.8-11.4,23.2-15.1,26.6c-2.1,2-3.8,2.9-4.8,3.3
        c-0.6,0.2-1.1,0.4-1.3,0.4c-0.2,0-0.3,0-0.4,0l-0.1,0c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0-0.4,0.1-0.8,0.2
        C83.4,122.3,82.8,122.4,82.1,122.4z M79.1,1.4C58.3,1.4,34.7,8,17.5,19.2C8,25.3,3.4,33.1,3.7,42.2c0.3,9.3,5.5,16.9,7.7,19.7l0,0
        C39,97,57.6,111.1,68.3,116.9c5.9,3.2,10.1,4.1,12.5,4.3c1.3,0.1,2.2,0,2.8-0.1c0.3,0,0.5-0.1,0.6-0.1l0.3-0.1l0.2,0
        c0.1,0,0.1,0,0.3,0c0.2,0,0.6-0.1,1.1-0.3c1-0.4,2.5-1.2,4.5-3.1c3.6-3.4,9.1-10.6,14.8-26.2c10.7-29,13.7-50.8,13-60.7
        c-0.3-4.1-0.7-10.4-4-15.8c-3.8-6.3-10.4-10.3-20.3-12C89.4,1.8,84.3,1.4,79.1,1.4z"
      />
    </g>
  </IconContainer>
);

export default DiscountRedIcon;
